// @flow

import * as React from 'react';
import { get } from 'lodash';

import { BadgeName } from '@app/components/badges/badge-name';
import { T } from '@app/components/translation';

import { RemoveConfirm } from '../remove-confirm';

export type Props = {
  role: Role,
  removeState: RemoveState,
  resetRemoveState: Function,
  removeRole: () => void,
  children: Function,
};

export class RemoveRole extends React.PureComponent<Props> {
  handleConfirm = () => {
    const { removeRole } = this.props;
    removeRole();
  };

  getCustomErrorMessage() {
    const { removeState } = this.props;
    const apiErrorCode = get(removeState, 'error.body.api_error_code');

    if (apiErrorCode !== 102) {
      return '';
    }

    return {
      bodyText: (
        <T
          _str="This role can't be deleted. To continue, remove assigned users or groups."
          _comment="Error text when not allowing deletion of a role."
        />
      ),
    };
  }

  renderBody() {
    const { role } = this.props;

    return (
      <T
        _str="You are about to delete {name}. This action can't be undone."
        name={<BadgeName>{role.name}</BadgeName>}
        _comment="Modal text when removing a role from the role list."
      />
    );
  }

  render() {
    const { removeState, children, resetRemoveState } = this.props;

    return (
      <RemoveConfirm
        onConfirm={this.handleConfirm}
        confirmState={removeState}
        resetConfirmState={resetRemoveState}
        confirmMessage={this.renderBody()}
        modalKey="delete role modal"
        customErrorMessage={this.getCustomErrorMessage()}
      >
        {children}
      </RemoveConfirm>
    );
  }
}
